import api from '../api';
import { acgRoutes, GET, PATCH, POST } from '../../constants/api';

export const getBQRoutinesSyncStatus = () => {
  return api({
    method: GET,
    url: acgRoutes.phase1.BQ_ROUTINES_SYNC_STATUS,
  });
};

export const syncBQRoutines = () => {
  return api({
    method: POST,
    url: acgRoutes.phase1.SYNC_BQ_ROUTINES,
  });
};

export const listBigQueryRoutines = () => {
  return api({
    method: GET,
    url: acgRoutes.phase1.LIST_BQ_ROUTINES,
  });
};

export const listArgumentsInRoutine = routineId => {
  return api({
    method: GET,
    url: acgRoutes.phase1.LIST_ROUTINES_ARGUMENTS(routineId),
  });
};

export const patchRoutineDefaultValues = (routineId, data) => {
  return api({
    method: PATCH,
    url: acgRoutes.phase1.UPDATE_ROUTINE_DEFAULT_VALUE(routineId),
    data,
  });
};

export const listCampaignGenerationJobs = (page, limit) => {
  return api({
    method: GET,
    url: acgRoutes.phase1.LIST_CAMPAIGN_GENERATION_JOBS,
    params: {
      page,
      limit,
    },
  });
};

export const getCampaignGenerationJob = jobId => {
  return api({
    method: GET,
    url: acgRoutes.phase1.GET_CAMPAIGN_GENERATION_JOB(jobId),
  });
};

export const generateCampaign = (routineName, argumentsObj) => {
  return api({
    method: POST,
    url: acgRoutes.phase1.GENERATE_CAMPAIGN,
    data: {
      routineName,
      arguments: argumentsObj,
    },
  });
};

export const createUploadUrls = data => {
  return api({
    method: POST,
    url: acgRoutes.phase1.CREATE_UPLOAD_URLS,
    data,
  });
};

export const createEmailExclusionJobFromUrls = data => {
  return api({
    method: POST,
    url: acgRoutes.phase1.CREATE_EMAIL_EXCLUSION_JOB,
    data,
  });
};

export const getEmailExclusionJobs = (page, limit) => {
  return api({
    method: GET,
    url: acgRoutes.phase1.GET_EMAIL_EXCLUSION_JOBS,
    params: {
      page,
      limit,
    },
  });
};

export const getEmailExclusionJob = jobId => {
  return api({
    method: GET,
    url: acgRoutes.phase1.GET_EMAIL_EXCLUSION_JOB(jobId),
  });
};
